module.exports = __webpack_public_path__ + "img/poster_count_cb.f19985ef.png";